const state = () => ({
  allData: [],
  totalData: 0,
  loading: false,
  errors: [],
  flashErrorMessage: '',
  flashError: false,
  item: null,
  intervalExport: null,
  exportId: null,
  countDataExport: 0,
  totalPage: 0,
  requestData: null,
  countSameRefund: 0,
  countDoneRefund: 0,
  refundId: null,
  countDataRefund: 0,
  intervalRefund : null,
  showProgressBar: false,
  percentage: 0,
  progressTitle: "Processing Request",
  progressColor: "grey",
  isFailedResponse: false,
});

export default state;
